import React from "react";
import { mergeClassName } from "../../../utils/helpers";
import useNavigateModal from "../../../hooks/useNavigateModal";

type props = {
  children: React.ReactNode;
  onclickBackDrop?: () => void;
  position?: boolean;
  className?: string;
};

function SideModal({ children, onclickBackDrop, position, className }: props) {
  const navigate = useNavigateModal();
  const defaultCloseHandler = () => {
    navigate();
  };
  return (
    <div
      onClick={onclickBackDrop || defaultCloseHandler}
      className="fixed top-0 left-0 z-50 h-full w-full overflow-y-auto bg-base-10 backdrop-blur-sm"
    >
      <div
        className={mergeClassName(
          "flex h-full w-full items-start",
          position ? "justify-start" : "justify-end"
        )}
      >
        <section
          onClick={(e) => e.stopPropagation()}
          className={mergeClassName(
            "min-h-screen w-5/6 bg-white  md:w-1/2",
            className
          )}
        >
          {children}
        </section>
      </div>
    </div>
  );
}

export default SideModal;
